export const supportEmail = 'support@ridereport.com';
